// All links with gtm-* classes will push their
// data attributes to the dataLayer on click.
const gtm = Array.from(document.querySelectorAll('a[class*="gtm-"]'));
gtm.forEach((link) => {
    link.addEventListener('click', () => {
        window.dataLayer.push(Object.assign({}, link.dataset));
    });
});

// Custom tracking for faqs.
const faqs = Array.from(document.querySelectorAll('.gtm-click-faq'));
faqs.forEach((faq) => {
    faq.addEventListener('click', () => {
        if (!faq.classList.contains('is-tracked')) {
            window.dataLayer.push({
                event: 'viewQuestion',
                faqName: faq.dataset.faqName,
            });

            faq.classList.add('is-tracked');
        }
    });
});

// All forms with trigger a custom event with their name.
const forms = Array.from(document.querySelectorAll('form'));
forms.forEach((form) => {
    form.addEventListener('submit', () => {
        const formHandle = form.querySelector('input[name="handle"]').value;
        switch (formHandle) {
        case 'contactForm':
            window.dataLayer.push({
                event: formHandle,
                enquiryType: form.querySelector('select[name="fields[topic]"]').value,
            });
            break;
        default:
            window.dataLayer.push({
                event: 'form-submit',
                formName: formHandle,
            });
        }
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/helpers.js